
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'flag-ch': {
    width: 640,
    height: 480,
    viewBox: '0 0 640 480',
    data: '<g fill-rule="evenodd" stroke-width="1pt"><path pid="0" _fill="#d52b1e" d="M0 0h640v480H0z"/><g _fill="#fff"><path pid="1" d="M170 195h300v90H170z"/><path pid="2" d="M275 90h90v300h-90z"/></g></g>'
  }
})
